export const data =
{
    teksti: 'Mies huojentuu kun ymmärtää, että olette kotihoidon työntekijöitä ja vahvistaa olevansa Pentti. Hän ei ollut osannut odottaa että eteisessä on porukkaa ja vaikuttaa hieman loukkaantuneelta kun tulitte ominne lupinenne sisälle. ',
    tarvittavaNoppaluku: 2,
    noppaMsg: "Heitä noppaa klikkaamalla nopan kuvaa. Pentti leppyy, jos saat silmäluvuksi vähintään ",
    optiot: []
};



